import { render } from "./ButtonTabletFormComponent.vue?vue&type=template&id=550a5ecf"
import script from "./ButtonTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./ButtonTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__